import {
	DPP_ORDER_COMPLETION_STORAGE_PREFIX,
	DPP_ORDER_COMPLETION_TIMEOUT_MS,
	DPP_PROXY_BASE_PATH,
} from '@/data/dpp/constants';
import type { DppOrderCompletionRequest } from '@/data/dpp/types';

const storageKeyOf = (orderId: string) => `${DPP_ORDER_COMPLETION_STORAGE_PREFIX}${orderId}`;

const isAlreadyReported = (orderId: string) => {
	try {
		return sessionStorage.getItem(storageKeyOf(orderId)) !== null;
	} catch {
		return false;
	}
};

const markReported = (orderId: string) => {
	try {
		sessionStorage.setItem(storageKeyOf(orderId), new Date().toISOString());
	} catch {
		return;
	}
};

const postCompletion = async ({ storeId, orderId, couponIds }: DppOrderCompletionRequest) => {
	await fetch(`${DPP_PROXY_BASE_PATH}/orders/${encodeURIComponent(orderId)}/completion`, {
		method: 'POST',
		keepalive: true,
		headers: { 'Content-Type': 'application/json', accept: 'application/json' },
		body: JSON.stringify({ storeId, couponIds }),
	});
	markReported(orderId);
};

export const reportDppOrderCompletion = async (
	request: DppOrderCompletionRequest
): Promise<void> => {
	if (typeof window === 'undefined' || !request.orderId || !request.storeId) return;
	if (isAlreadyReported(request.orderId)) return;

	let timer: ReturnType<typeof setTimeout> | undefined;
	const timeout = new Promise<void>((resolve) => {
		timer = setTimeout(resolve, DPP_ORDER_COMPLETION_TIMEOUT_MS);
	});

	await Promise.race([postCompletion(request).catch(() => undefined), timeout]);
	clearTimeout(timer);
};
